import { AddToCartProductTactic, AddToCartProductTacticInput } from '@Generated/graphql'

export function createAddToCartTacticFromOffer(offer: AddToCartProductTactic): NonNullable<AddToCartProductTacticInput> {
  if (!offer.price) {
    throw new Error('Offer price is required')
  }
  return {
    checksum: offer.checksum,
    type: offer.type,
    price: {
      currencyCode: offer.price.currencyCode,
      value: offer.price.value,
      discount: offer.price.discount
        ? {
          currencyCode: offer.price.discount.currencyCode,
          percent: offer.price.discount.percent,
          value: offer.price.discount.value,
        }
        : undefined,
    },
  }
}
